"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8626],{

/***/ 48626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ PHONE_ACCEPTS; },
  "Z": function() { return /* binding */ Form_PhoneField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Tooltip/index.js + 4 modules
var Tooltip = __webpack_require__(16729);
// EXTERNAL MODULE: ./components/Icons/ArrowDownLite.js
var ArrowDownLite = __webpack_require__(17944);
// EXTERNAL MODULE: ./lib/phoneNumber.js + 2 modules
var phoneNumber = __webpack_require__(58475);
;// CONCATENATED MODULE: ./components/Form/PhoneInput.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Composite phone control: a country prefix inside the field plus an input
// holding only the national number. The prefix is a real <select>, so it cannot
// be backspaced away, and the input never contains a "+".
var PhoneInput = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, active = _meta.active, validateOn = props.validateOn, showErrors = props.showErrors, inputClassName = props.inputClassName, labelClass = props.labelClass, tooltip = props.tooltip, countryCode = props.countryCode, countryOptions = props.countryOptions, countryEditable = props.countryEditable, onCountryChange = props.onCountryChange, inputProps = _objectWithoutProperties(props, [
        "input",
        "meta",
        "validateOn",
        "showErrors",
        "inputClassName",
        "labelClass",
        "tooltip",
        "countryCode",
        "countryOptions",
        "countryEditable",
        "onCountryChange"
    ]);
    var country = countryCode || phoneNumber/* ROMANIA_COUNTRY_CODE */.Ct;
    var showInputErrorCondition = validateOn === "active" ? active || touched : touched;
    var hasError = Boolean(error) && showInputErrorCondition;
    // One country means nothing to choose, so the field renders as it did before
    // this control existed.
    var showCountryPicker = Boolean(countryEditable && countryOptions && countryOptions.length > 1);
    // The prefix without a select: on a DHL address the country belongs to the
    // address, so it is shown but not the customer's to change here.
    var showPrefix = showCountryPicker || !countryEditable;
    var fieldId = props.id || input.name;
    var selectId = "".concat(fieldId, "_country");
    var errorId = "".concat(fieldId, "_error");
    var inputRef = (0,react.useRef)(null);
    var caretRef = (0,react.useRef)(null);
    // Move a full number into (select, input) instead of leaving it in the input.
    var applyInternational = function(raw) {
        var pasted = (0,phoneNumber/* splitPastedPhone */.jz)(raw);
        if (!pasted) {
            return false;
        }
        var isOffered = !countryOptions || countryOptions.some(function(option) {
            return option.value === pasted.countryCode;
        });
        // A country we do not offer must not land in the select: keep the current one
        // and let the validator explain. Same when the country is not editable - it
        // belongs to the address, and pasting a phone must not move the address.
        if (countryEditable && isOffered && pasted.countryCode !== country) {
            onCountryChange(pasted.countryCode);
        }
        input.onChange(pasted.national);
        return true;
    };
    var handleChange = function(event) {
        var element = event.target;
        var raw = element.value;
        // Catches autofill and a "00..." number typed by hand, which survives
        // digit-only sanitizing. "00" can never start a Romanian number.
        if (/^00\d/.test((0,phoneNumber/* sanitizePhone */.o)(raw)) && applyInternational(raw)) {
            return;
        }
        var _selectionStart;
        // Digits surviving left of the old caret, so it does not jump to the end when
        // a separator is stripped.
        var caret = (_selectionStart = element.selectionStart) !== null && _selectionStart !== void 0 ? _selectionStart : raw.length;
        caretRef.current = (0,phoneNumber/* sanitizeNational */.Hy)(raw.slice(0, caret)).length;
        input.onChange((0,phoneNumber/* sanitizeNational */.Hy)(raw));
    };
    var handlePaste = function(event) {
        var ref;
        var ref1;
        var pasted = (ref1 = (ref = event.clipboardData) === null || ref === void 0 ? void 0 : ref.getData("text")) !== null && ref1 !== void 0 ? ref1 : "";
        // Not international: let the browser paste, handleChange sanitizes it.
        if (!(0,phoneNumber/* splitPastedPhone */.jz)(pasted)) {
            return;
        }
        event.preventDefault();
        applyInternational(pasted);
    };
    // useEffect, not useLayoutEffect: Next warns on the latter during SSR.
    (0,react.useEffect)(function() {
        var element = inputRef.current;
        if (element && caretRef.current !== null && document.activeElement === element) {
            element.setSelectionRange(caretRef.current, caretRef.current);
        }
        caretRef.current = null;
    }, [
        input.value
    ]);
    var _obj;
    var telephoneInput = /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, input, inputProps, {
        ref: inputRef,
        id: fieldId,
        type: "tel",
        inputMode: "tel",
        autoComplete: "tel-national",
        autoCorrect: "off",
        "aria-invalid": hasError || undefined,
        "aria-describedby": hasError ? errorId : undefined,
        onChange: handleChange,
        onPaste: handlePaste,
        className: classnames_default()((_obj = {}, _defineProperty(_obj, props.className, props.className), _defineProperty(_obj, inputClassName, inputClassName), _defineProperty(_obj, "Form-phone-input", showPrefix), _defineProperty(_obj, "error border-red-brand bg-red-bg", !showPrefix && hasError), _obj))
    }));
    var _obj1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: fieldId,
                className: classnames_default()("Form-label", (_obj1 = {}, _defineProperty(_obj1, labelClass, labelClass), _defineProperty(_obj1, "is-required", props.required), _defineProperty(_obj1, "disabled", props.disabled), _obj1)),
                children: [
                    typeof props.label === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label,
                    tooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                content: tooltip,
                                mode: "click"
                            })
                        ]
                    })
                ]
            }),
            showPrefix ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showCountryPicker && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: selectId,
                        className: "sr-only",
                        children: props.prefixLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("Form-phone", {
                            error: hasError,
                            disabled: props.disabled
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "Form-phone-prefix",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": showCountryPicker || undefined,
                                        children: [
                                            (0,phoneNumber/* countryCodeToFlag */.q9)(country),
                                            (0,phoneNumber/* getDisplayCallingCode */.LM)(country)
                                        ].filter(Boolean).join(" ")
                                    }),
                                    showCountryPicker && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownLite/* default */.Z, {
                                                width: "9px",
                                                height: "6px",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                id: selectId,
                                                name: "".concat(input.name, "_country"),
                                                className: "Form-phone-select",
                                                value: country,
                                                disabled: props.disabled,
                                                "aria-invalid": hasError || undefined,
                                                "aria-describedby": hasError ? errorId : undefined,
                                                autoComplete: "tel-country-code",
                                                onChange: function(event) {
                                                    return onCountryChange(event.target.value);
                                                },
                                                children: countryOptions.map(function(option) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                        value: option.value,
                                                        children: [
                                                            (0,phoneNumber/* countryCodeToFlag */.q9)(option.value),
                                                            option.label,
                                                            (0,phoneNumber/* getDisplayCallingCode */.LM)(option.value) && "(".concat((0,phoneNumber/* getDisplayCallingCode */.LM)(option.value), ")"), 
                                                        ].filter(Boolean).join(" ")
                                                    }, option.value);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            telephoneInput
                        ]
                    })
                ]
            }) : telephoneInput,
            showErrors && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: errorId,
                className: classnames_default()("text-red-brand text-sm mt-2px", {
                    hidden: !hasError
                }),
                children: error
            })
        ]
    }));
};
PhoneInput.defaultProps = {
    showErrors: true,
    validateOn: "touched",
    countryEditable: true,
    id: undefined,
    label: undefined,
    tooltip: null,
    required: undefined,
    disabled: undefined,
    placeholder: undefined,
    prefixLabel: "Prefix telefonic international"
};
/* harmony default export */ var Form_PhoneInput = (PhoneInput);

// EXTERNAL MODULE: ./store/user/actions.js
var actions = __webpack_require__(49865);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
;// CONCATENATED MODULE: ./components/Form/PhoneField.js









function PhoneField_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PhoneField_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PhoneField_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PhoneField_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PhoneField_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PhoneField_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// No default, on purpose: a boolean would be silently wrong on half the surfaces
// whichever way it defaulted.
var PHONE_ACCEPTS = {
    // Registration, the 426 gate, account addresses.
    FIXED_OR_MOBILE: "fixed-or-mobile",
    // The SMS modal only: it sends a code, so a landline cannot complete the flow.
    MOBILE_ONLY: "mobile-only"
};
var _obj;
var VALIDATOR_BY_ACCEPTS = (_obj = {}, PhoneField_defineProperty(_obj, PHONE_ACCEPTS.FIXED_OR_MOBILE, validations/* isPhoneNumberForCountry */.S3), PhoneField_defineProperty(_obj, PHONE_ACCEPTS.MOBILE_ONLY, validations/* isMobileNumberForCountry */.mX), _obj);
var _obj1;
// Derived from `accepts` like the validator, so the copy cannot drift from the
// rule it describes. A caller can still override with its own `tooltip`.
var TOOLTIP_BY_ACCEPTS = (_obj1 = {}, PhoneField_defineProperty(_obj1, PHONE_ACCEPTS.FIXED_OR_MOBILE, /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
        "Sunt acceptate numere de telefon fix sau mobil. Alege prefixul tarii din lista, apoi introdu numarul fara prefixul international.",
        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
        "Ex. pentru Romania: 07XXXXXXXX; 02XXXXXXXX."
    ]
})), PhoneField_defineProperty(_obj1, PHONE_ACCEPTS.MOBILE_ONLY, /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
        "Sunt acceptate doar numere de telefon mobil, pentru ca pe ele trimitem codul prin SMS. Alege prefixul tarii din lista, apoi introdu numarul fara prefixul international.",
        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
        "Ex. pentru Romania: 07XXXXXXXX."
    ]
})), _obj1);
// Drop-in replacement for a <Field name="telephone" component={InputText} />.
//
// react-final-form 4.1.0 has no field hooks, so the country comes from an outer
// <Field> render-prop rather than form.change(). That is what lets this work in
// class components too.
var PhoneField = function(_param) {
    var _name = _param.name, name = _name === void 0 ? "telephone" : _name, _countryFieldName = _param.countryFieldName, countryFieldName = _countryFieldName === void 0 ? "telephone_country_code" : _countryFieldName, accepts = _param.accepts, _required = _param.required, required = _required === void 0 ? false : _required, tooltip = _param.tooltip, // Without this, the account phone list. Pass the DHL delivery list when the
    // country being asked about is the address's.
    countryOptions = _param.countryOptions, _countryEditable = _param.// false renders the prefix as a read-only indicator: on a DHL address the
    // country is the address's, not the customer's to choose here.
    countryEditable, countryEditable = _countryEditable === void 0 ? true : _countryEditable, phoneCountries = _param.phoneCountries, getPhoneCountries1 = _param.getPhoneCountries, // Swallowed, never forwarded: a stray validate= would silently replace the
    // country-aware rule.
    callerValidate = _param.validate, rest = PhoneField_objectWithoutProperties(_param, [
        "name",
        "countryFieldName",
        "accepts",
        "required",
        "tooltip",
        "countryOptions",
        "countryEditable",
        "phoneCountries",
        "getPhoneCountries",
        "validate"
    ]);
    var options = countryOptions !== null && countryOptions !== void 0 ? countryOptions : phoneCountries;
    // Keyed on the resolved options, so a caller passing its own list never fetches
    // one it will not use.
    (0,react.useEffect)(function() {
        if (!options) {
            getPhoneCountries1();
        }
    }, [
        options,
        getPhoneCountries1
    ]);
    var resolvedValidator = VALIDATOR_BY_ACCEPTS[accepts];
    // Throw in dev rather than warn: a misspelled `accepts` would otherwise pick
    // the permissive fallback below unnoticed.
    if (false) {}
    // In production prefer the permissive rule over crashing the page.
    var validator = resolvedValidator !== null && resolvedValidator !== void 0 ? resolvedValidator : validations/* isPhoneNumberForCountry */.S3;
    // Country read from allValues, NOT closed over: pasting a foreign number changes
    // the country and the number in one handler, before React re-renders, so a
    // captured country would still be the previous one. composeFormValidators is
    // avoided because it drops allValues.
    var validate = (0,react.useCallback)(function(value, allValues) {
        if (required) {
            var requiredError = (0,validations/* isRequired */.q9)()(value);
            if (requiredError) {
                return requiredError;
            }
        }
        var country = allValues && allValues[countryFieldName] || phoneNumber/* ROMANIA_COUNTRY_CODE */.Ct;
        return validator(country)(value);
    }, [
        countryFieldName,
        required,
        validator
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: countryFieldName,
        subscription: {
            value: true
        },
        children: function(param) {
            var countryInput = param.input;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, PhoneField_objectSpread({}, rest, {
                name: name,
                component: Form_PhoneInput,
                required: required,
                tooltip: tooltip !== null && tooltip !== void 0 ? tooltip : TOOLTIP_BY_ACCEPTS[accepts],
                countryCode: countryInput.value || phoneNumber/* ROMANIA_COUNTRY_CODE */.Ct,
                countryOptions: options,
                countryEditable: countryEditable,
                onCountryChange: countryInput.onChange,
                validate: validate
            }));
        }
    }));
};
PhoneField.propTypes = {
    accepts: prop_types_default().oneOf(Object.values(PHONE_ACCEPTS)).isRequired,
    name: (prop_types_default()).string,
    countryFieldName: (prop_types_default()).string,
    countryOptions: prop_types_default().arrayOf(prop_types_default().shape({
        label: (prop_types_default()).string,
        value: (prop_types_default()).string
    })),
    countryEditable: (prop_types_default()).bool,
    required: (prop_types_default()).bool
};
/* harmony default export */ var Form_PhoneField = ((0,es/* connect */.$j)(function(state) {
    return {
        phoneCountries: state.user.phoneCountries
    };
}, {
    getPhoneCountries: actions/* getPhoneCountries */.wT
})(PhoneField));


/***/ })

}]);